import React from "react";
import "./SuccessPopup.css";

function SuccessPopup({ title, message, onClose, buttonLabel = "Done" }) {
  return (
    <div className="pw-modal-backdrop" onClick={onClose}>
      <div
        className="pw-modal"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <div className="pw-modal-icon">
          <span className="pw-checkmark">✓</span>
        </div>

        <h2 className="pw-modal-title">{title}</h2>
        {message && <p className="pw-modal-message">{message}</p>}

        <button className="pw-modal-button" onClick={onClose}>
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}

export default SuccessPopup;
